const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].HepatitisA[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[12]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].HepatitisB[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[11]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].HepatitisC[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Autoimmunehepatitis[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Drug-inducedhepatitis[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[8]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Hemochromatosis[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[2]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Cirrhosisoftheliver[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[7]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Primarybiliarycirrhosis[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[3]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Sclerosingcholangitis[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[4]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Livertransplantcandidate[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[6]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].Livertransplant[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[5]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].Diagnosis1[1]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[9]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].Diagnosis1[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[10]",
        },     
    ]

}

export default ssn ;